/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/IncidentsPageLinkedServicesWrapperSrcQuery$parameters.ts';
import type { IncidentsPageLinkedServicesWrapperSrcQuery } from './__generated__/IncidentsPageLinkedServicesWrapperSrcQuery.graphql.ts';

type IncidentsPageEntryPointComponent = EntryPointComponent<
	{
		incidentPageData: IncidentsPageLinkedServicesWrapperSrcQuery;
	},
	{},
	{},
	{}
>;

export const incidentsPageEntryPoint: EntryPoint<
	IncidentsPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<IncidentsPageEntryPointComponent>(
		/* webpackChunkName: "async-incidents-page" */ './IncidentsPageLinkedServicesWrapper.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId }, context }: EntryPointRouteParams) => ({
		queries: {
			incidentPageData: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					cloudId,
					projectKey: context.match.params.projectKey ?? '',
				},
			},
		},
	}),
});
